import React from 'react';
import { Form, Button, Icon, Message, Dropdown } from 'semantic-ui-react'
import _find from 'lodash/find';

import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../../utils/queries';


//dropdown EMPRESAS

const DetalleNivel1 = props => {
  // let marca=props.elemento.tipoProducto + " - "
  let precio = ""
  // if(props.elemento.marca){
  //   marca += props.elemento.marca + " - "
  // }
  if(props.elemento.precio){
    precio += " ==> Vlr Und: " + props.elemento.precio
  }
  return (
    <option dato1={props.elemento.tipoProducto} dato2={props.elemento.ficha?props.elemento.ficha:''} 
    dato3={props.elemento.descrUnidad?props.elemento.descrUnidad:''} 
    dato4={props.elemento.precio?props.elemento.precio:0} 
    dato5={props.elemento.porcIVA?props.elemento.porcIVA:0} 
    dato6={props.elemento.precioDolar?props.elemento.precioDolar:0} 
    dato7={props.elemento.porcImpto?props.elemento.porcImpto:0}
    dato8={props.elemento.ficha2?props.elemento.ficha2:''}
    dato9={props.elemento.vigenteHasta?props.elemento.vigenteHasta:''}
    dato10={props.elemento.estado?props.elemento.estado:''}
    dato11={props.elemento.numProducto} dato12={props.elemento.descrCorta?props.elemento.descrCorta:''}
    value={props.elemento.descrProducto}>{props.elemento.descrProducto}{precio}</option>
  )
};

const ListaPro = ({list, handleLista}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui fluid search selection dropdown" name="descrProducto" id="miLista44" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

// const ListaMon = ({handleLista}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name="moneda" id="miLista55" onChange={handleLista}>
//         <option>Seleccionar...</option>
//         <option>Pesos</option>
//         <option>Dolares</option>
//       </select>
//     </div>
//   )
// };

  class AddItemCoti2 extends React.Component{
    state={argsAdd: {}, listaItem: this.props.allProducto.allProducto}

  // handleChange = async (ev) => {
  //   const argsAdd = this.state.argsAdd
  //   console.log(argsAdd)

  //   this.setState({argsAdd})
  // }

  render(){
   const { argsAdd} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    let args = Object.assign({}, this.props.args, argsAdd)
console.log(this.props.idLista)
    args._id = this.props.idLista._id
    args.numCoti = this.props.idLista.numCoti
    args.monedaCoti = this.props.idLista.monedaCoti?this.props.idLista.monedaCoti:'Pesos'
    args.imptoCoti = this.props.idLista.imptoCoti?this.props.idLista.imptoCoti:'IVA'
    let listPro=[]
    let listaItem=[]
    if(this.props.allProducto.allProducto){listaItem = this.props.allProducto.allProducto}

    let buscItem = ''
    if(args.descrProductoB){
      buscItem = args.descrProductoB
    }
    if(listaItem && listaItem.length>0){
      listPro = listaItem.filter(elemento => elemento.tipoProducto===this.props.tipoC && elemento.estado==='Activo')
      if(buscItem){
        listPro = listPro.filter(elemento => elemento.descrProducto.toLowerCase().indexOf(buscItem.toLowerCase()) > -1)
      }
    }
    let incremento=0
    if(this.props.idLista.tipo==='Producto'){
      switch(this.props.idLista.formaPago){
        case 'Anticipado 100%':
          incremento=0;
          break
        case 'Anticipo 50% contra entrega 50%':
          incremento=5;
          break
        case 'Contra entrega 100%':
          incremento=10;
          break
        case 'Pago = 30 días':
          incremento=15;
          break
        case 'Pago entre 30 >= y < 60 días':
          incremento=20;
          break
        case 'Pago entre 60 >= y < 90 días':
          incremento=25;
          break
        case 'Pago >= 90 días':
          incremento=30;
          break
      }
    }
    console.log(args, incremento) 
    let zonaFranca="No"
    if(this.props.idLista.zonaFranca==='Si'){
      zonaFranca="Si" 
    }
    let tipo=this.props.idLista.tipo

    return(
  
    <div>
      {/* <head>
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
        <link href="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css" rel="stylesheet" />
        <script src="https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js"></script>
      </head> */}
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Item nuevo
      </button>
      <div style={this.props.styles.box}>
        <Form onSubmit={(ev)=>this.props.handleSubmit(ev, args, incremento, zonaFranca, tipo)}>
          <div className="ui eight column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '29%'}}>                
                <Form.Field>
                  <div className="ui input fluid">
                    <input id='descrProductoB' autoComplete="off" name="descrProductoB" type="text" placeholder="Buscar producto" style={this.props.styles.dropdown} onChange={this.props.handleChange}/>
                  </div>
                </Form.Field>    
              </div>
            </div>
            <div className="row container">
              <div className="column" style={{width: '29%'}}>  
                <label style={this.props.styles.label}>Producto</label>
                <Form.Field>
                  <ListaPro list={listPro} handleLista={this.props.handleLista} />
                </Form.Field>    
              </div>
              {/* <div className="column" style={{width: '12%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Moneda</label>
                  <ListaMon styles={this.props.styles} handleLista={this.props.handleLista2} />
                </Form.Field>
              </div> */}
              {(args.descrProducto==='Transporte' || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte') &&
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Precio</label>
                    <input type='number' step="0.01" min="0" autoComplete="off" name="precio" id="precio" placeholder='Precio' onChange={this.props.handleChange}/>
                  </Form.Field>
                </div>
              }
              <div className="column" style={{width: '8%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>Cantidad</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="cantidadCoti" id="cantidadCoti" placeholder='Cantidad' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              <div className="column" style={{width: '9%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>% Descuento</label>
                  <input type='number' step="1" min="0" autoComplete="off" name="porcDcto" id="porcDcto" placeholder='% Descuento' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              {(this.props.idLista.tipo==='Producto') &&
                <div className="column" style={{width: '9%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% Incremento</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="porcIncremento" id="porcIncremento" placeholder='% Incremento' value={incremento} readOnly/>
                  </Form.Field> 
                </div>
              }
              {(this.props.idLista.tipo!=='Producto') &&
                <div className="column" style={{width: '9%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% Incremento</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="porcIncremento1" id="porcIncremento1" placeholder='% Incremento' onChange={this.props.handleChange}/>
                  </Form.Field> 
                </div>
              }
              <div className="column" style={{width: '9%'}}>
                <Form.Field>
                  <label style={this.props.styles.label}>$ Transporte</label>
                  <input type='number' step="0.1" min="0" autoComplete="off" name="recargoTransp" id="recargoTransp" placeholder='Transporte' onChange={this.props.handleChange}/>
                </Form.Field> 
              </div>
              {(args.descrProducto==='Transporte' || args.descrProducto==='Transporte producto' || args.descrProducto==='Alojamiento, alimentación y transporte') &&
                <div className="column" style={{width: '8%'}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>% Impto</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="porcIVA" id="porcIVA" placeholder='% IVA' onChange={this.props.handleChange}/>
                  </Form.Field> 
                </div>
              }
            </div>
          </div>
          <div className="row container">
            <div className="column" width="100%">                
              <Button style={this.props.styles.confirmar} type='submit' fluid>
                AGREGAR
              </Button>
            </div>
            {
              this.props.errors.length?<Message negative header="Los siguientes errores:"
              list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
          </div>
        </Form>
      </div>
      {/* <script type="text/javascript">
        $(document).ready(function(){
          ('#mibuscador').select2();
        });
      </script> */}
    </div>
    
  )
  }
}

// export default AddProcEjec2
export default compose(
  graphql(queries.query.allProducto, {name:'allProducto'}),
  )(AddItemCoti2)